import { Section } from "./Section.tsx";


export function ContactCTA() {
  return <>
    {/* <Section></Section> */}
    <Section data-accent data-contact-cta>
      <hr />
      <div className="spaced">
        <div>
          <h2>Talk with an expert</h2>
          <p>Looking to elevate your technology game? Chat with a friendly Gage Technologies expert today! We’ll work together to find the perfect solutions for your unique needs, driving success with a personal touch. Reach out now to get started!</p>
        </div>
        <a href="/contact" class="button">Contact&nbsp;Us</a>
      </div>
      <hr />
    </Section>
  </>
}